<input type="text" [formControl]="formControl" [placeholder]="placeholder()" />
